/**
 * 清理购物车中积分商品的属性
 * 当购物车中全部都是积分商品时：
 * 删除它们的自定义属性后重新添加
 */
(function () {
  const LOYALTY_PROP_KEY = "_loyalty_discount_type";
  const CHECKOUT_LOCK_CLASS = "loyalty-checkout-disabled";
  let isProcessing = false;
  let checkoutEnabled = true;

  const checkoutButtonStyle = document.createElement("style");
  checkoutButtonStyle.textContent = `
    .${CHECKOUT_LOCK_CLASS} .drawer__footer-buttons button,
    .${CHECKOUT_LOCK_CLASS} .drawer__footer-buttons a,
    .${CHECKOUT_LOCK_CLASS} .cart__sidebar button,
    .${CHECKOUT_LOCK_CLASS} .cart__sidebar a,
    .${CHECKOUT_LOCK_CLASS} .additional-checkout-buttons {
      pointer-events: none !important;
      opacity: 0.6 !important;
      cursor: not-allowed !important;
    }
  `;
  document.head?.appendChild(checkoutButtonStyle);

  function setCheckoutButtons(enabled) {
    checkoutEnabled = enabled;
    document.documentElement.classList.toggle(CHECKOUT_LOCK_CLASS, !enabled);
    refreshCheckoutButtons();
  }

  function refreshCheckoutButtons() {
    document
      .querySelectorAll(
        ".drawer__footer-buttons button, .drawer__footer-buttons a," +
        ".cart__sidebar button, .cart__sidebar a," +
        ".additional-checkout-buttons",
      )
      .forEach((btn) => {
        btn.disabled = !checkoutEnabled;
        btn.style.pointerEvents = checkoutEnabled ? "auto" : "none";
        btn.style.opacity = checkoutEnabled ? "" : "0.6";
      });
  }

  // 监听新渲染的按钮，保持状态一致
  const checkoutButtonObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (
          node.matches(".drawer__footer-buttons, .cart__sidebar, .additional-checkout-buttons") ||
          node.querySelector(".drawer__footer-buttons, .cart__sidebar, .additional-checkout-buttons")
        ) {
          refreshCheckoutButtons();
        }
      });
    });
  });

  checkoutButtonObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  async function updateCartCount() {
    try {
      const cartRes = await fetch("/cart.js");
      const cartData = await cartRes.json();
      document.querySelectorAll(".cart-drawer-button .count").forEach((el) => {
        el.textContent = cartData.item_count;
        el.classList.remove("hidden");
        el.style.display = "inline-block";
      });
      document.querySelectorAll(".drawer__tabs .count").forEach((el) => {
        el.textContent = cartData.item_count + " items";
      });
    } catch (error) {
      console.error("Failed to update cart count:", error);
    }
  }

  /**
   * 异步检查购物车内容，决定是否恢复按钮
   * 调用前必须已经同步禁用了按钮
   */
  async function syncButtonState() {
    if (isProcessing) return;

    try {
      const cart = await fetch(`${theme.routes.cart_url}.json`).then((r) =>
        r.json(),
      );

      const loyaltyItems = cart.items.filter(
        (item) => item.properties && item.properties[LOYALTY_PROP_KEY],
      );
      const normalItems = cart.items.filter(
        (item) => !item.properties || !item.properties[LOYALTY_PROP_KEY],
      );

      // 全部是积分商品 → 保持禁用
      if (loyaltyItems.length > 0 && normalItems.length === 0) {
        setCheckoutButtons(false);
        return;
      }

      // 有正常商品或购物车为空 → 恢复按钮
      setCheckoutButtons(true);
    } catch (error) {
      console.error("Failed to sync button state:", error);
      setCheckoutButtons(true);
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    updateCartCount();
    // 同步立即禁用，再异步判断
    setCheckoutButtons(false);
    syncButtonState();
    check();
    document.querySelectorAll(".drawer_footerButton").forEach((btn) => {
      if (!btn.getAttribute("data-original-text")) {
        btn.setAttribute("data-original-text", btn.textContent);
      }
    });
  });

  // cart:updated：同步立即禁用 → 异步判断是否恢复
  document.addEventListener("cart:updated", () => {
    setCheckoutButtons(false); // 同步，无延迟
    syncButtonState();         // 异步，fetch 后决定是否恢复
    updateCartCount();
  });

  document.addEventListener("cart:refresh", () => {
    setCheckoutButtons(false);
    refreshCheckoutButtons();
    syncButtonState();
    updateCartCount();
  });

  // 点击删除时立即禁用，封住点击到 cart:updated 之间的空档
  function handleDeleteInteraction(target) {
    if (
      target.matches("[data-cart-remove]") ||
      target.closest("[data-cart-remove]") ||
      target.matches(".cart-remove") ||
      target.closest(".cart-remove") ||
      target.matches("[data-remove-item]") ||
      target.closest("[data-remove-item]") ||
      target.matches(".remove-item") ||
      target.closest(".remove-item") ||
      target.matches("[data-cart-delete]") ||
      target.closest("[data-cart-delete]") ||
      target.matches(".cart-delete") ||
      target.closest(".cart-delete") ||
      target.matches("button[aria-label*='Remove']") ||
      target.matches("button[title*='Remove']") ||
      target.matches("a[href*='/cart/change']") ||
      target.closest("a[href*='/cart/change']")
    ) {
      setCheckoutButtons(false);
      return true;
    }
    return false;
  }

  document.addEventListener("pointerdown", (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    handleDeleteInteraction(target);
  }, true);

  document.addEventListener("click", (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    handleDeleteInteraction(target);
  });

  async function check() {
    if (isProcessing) return;

    try {
      const cart = await fetch(`${theme.routes.cart_url}.json`).then((r) =>
        r.json(),
      );

      console.log("Current cart:", cart);

      const loyaltyItems = cart.items.filter(
        (item) => item.properties && item.properties[LOYALTY_PROP_KEY],
      );
      const normalItems = cart.items.filter(
        (item) => !item.properties || !item.properties[LOYALTY_PROP_KEY],
      );

      console.log("Loyalty items:", loyaltyItems);
      console.log("Normal items:", normalItems);

      if (loyaltyItems.length === 0 || normalItems.length > 0) {
        return;
      }

      isProcessing = true;
      setCheckoutButtons(false);

      for (const item of loyaltyItems) {
        console.log("Processing loyalty item:", item);

        await fetch(theme.routes.cart_change_url, {
          ...theme.utils.fetchConfig(),
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        });

        await fetch(theme.routes.cart_add_url, {
          ...theme.utils.fetchConfig("javascript"),
          body: JSON.stringify({ id: item.variant_id, quantity: item.quantity }),
        });
      }

      isProcessing = false;

      if (window.location.pathname === "/cart") {
        // 直接禁用后立刻刷新，不给按钮任何恢复机会
        setCheckoutButtons(false);
        window.location.reload();
      } else {
        await syncButtonState();
        document.dispatchEvent(
          new CustomEvent("cart:refresh", { detail: { open: true } }),
        );
      }
    } catch (error) {
      console.error("Failed to remove loyalty properties:", error);
      isProcessing = false;
      syncButtonState();
    }
  }

  const debouncedCheck = theme.utils.debounce(check, 200);
  document.addEventListener("cart:updated", debouncedCheck);
})();